import type { CustomerInfo } from '@/integrations/revenuecat/types';

export async function getCustomerInfo(): Promise<CustomerInfo | null> {
  if (import.meta.env.VITE_PLATFORM === 'MOBILE') {
    const { getCustomerInfoCapacitor } =
      await import('./getCustomerInfoCapacitor');
    return getCustomerInfoCapacitor();
  }

  const { getCustomerInfoJs } = await import('./getCustomerInfoJs');
  return getCustomerInfoJs();
}
